import { render, staticRenderFns } from "./Importar.vue?vue&type=template&id=06517cd0&"
import script from "./Importar.vue?vue&type=script&lang=ts&"
export * from "./Importar.vue?vue&type=script&lang=ts&"
import style0 from "./Importar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('06517cd0', component.options)
    } else {
      api.reload('06517cd0', component.options)
    }
    module.hot.accept("./Importar.vue?vue&type=template&id=06517cd0&", function () {
      api.rerender('06517cd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/Importar.vue"
export default component.exports